import React from "react";
import StylesProvider from "@material-ui/styles/StylesProvider";
import { create } from "jss";
import jssPreset from "@material-ui/styles/jssPreset";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import theme from "../../styles/theme";
import PropTypes from "prop-types";

export default function Motif(props) {
  let jss = create({
    ...jssPreset(),
    insertionPoint: document.getElementById("jss-insertion-point")
  });

  return (
    <StylesProvider jss={jss}>
      <MuiThemeProvider theme={theme} {...props} />
    </StylesProvider>
  );
}

Motif.propTypes = {
  children: PropTypes.node.isRequired
};
